import React from 'react'
import HeroSection from '../components/home/HeroSection'
import FeaturesSection from '../components/home/FeaturesSection'
import WorkflowSection from '../components/home/WorkflowSection'
import UseCasesSection from '../components/home/UseCasesSection'
import FAQSection from '../components/home/FAQSection'

const HomePage = () => {
  return (
    <main data-component-path="client/src/pages/HomePage.jsx" data-component-line="10:4" data-component-id="client/src/pages/HomePage.jsx:10:4" className="pt-20">
      <HeroSection />
      <FeaturesSection />
      <WorkflowSection />
      <UseCasesSection />
      <FAQSection />
    </main>
  )
}

export default HomePage